import React, { useEffect, useState } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import './styles.scss';
import { DetailsContainer } from '@ui-modules';
import {
  getChartProps,
  getRandomColor,
  overallSummaryData,
} from '@pages/RequestsDetailsPage/components/QuotationManagement/components/LineItemAssignment/components/AssignmentOverview/utils';
import { ILineItemCurrency, ILineItemsData, ISelectedItems } from '@common/interfaces/Common';

ChartJS.register(ArcElement, Tooltip);

interface IAssignmentListProps {
  selectedLineItems: ISelectedItems;
  data: ILineItemsData[];
  currencies: ILineItemCurrency;
}

const AssignmentOverview = ({ selectedLineItems, data, currencies }: IAssignmentListProps) => {
  const [hexColors, setHexColors] = useState<string[]>([]);

  useEffect(() => {
    if (data[0]?.values) {
      setHexColors(Object.keys(data[0]?.values).map(() => getRandomColor()));
    }
  }, [data]);

  const chartProps = getChartProps(selectedLineItems, data, hexColors, currencies);
  const labels = Object.keys(selectedLineItems).filter((label) => selectedLineItems[label].length);

  return (
    <div className="assignment-overview-wrapper">
      <div className="cost-overview-wrapper">
        <p>Assignment cost overview</p>
        <div className="chart-wrapper">
          <div className="chart-doughnut">
            <Doughnut {...chartProps} />
          </div>
          <div className="chart-labels">
            {labels.map((label, index) => (
              <div className="chart-label" key={label}>
                <div
                  className="chart-mark"
                  style={{
                    background: hexColors[index],
                  }}
                />
                <div className="chart-text">{label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="overall-details">
        <p>Overall cost breakdown</p>
        <DetailsContainer
          className="overall-details-list"
          items={overallSummaryData(selectedLineItems, data, currencies)}
        />
      </div>
    </div>
  );
};

export default AssignmentOverview;
